import Common from './common';

export default {
    basePath: "http://localhost:9900/mcab-core-web-1.0",
    //basePath: "http://m-cab.ru/mcab-core-web-1.0",
    props: {
        "appName": "Grace Logic",
        "defaultLang": "ru"
    }
};



// WEBPACK FOOTER //
// ./src/application.js